/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://c7m3k7llgzgxro6mhz5sysh44e.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:b87703a2-8aed-42e4-9ec6-eae8816a74bc",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_BYnve8yoj",
    "aws_user_pools_web_client_id": "73jp4bjenf0go34986pi19go4a",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ObjectAudit-previewdr",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "alucio-beacon-content180602-previewdr",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
